import React, { memo, useEffect, useCallback } from 'react';
import styles from './styles.module.css';
import { Table, Loading } from '../../../../../common/ui';
import { getStocks } from '../../actions';
import { connect } from 'react-redux';

const StockTable = memo(
  ({
    getStocks,
    auth: { branchId },
    stocksState: { stocksData, isLoading, totalRecords, currentPage, rowsPerPage },
    filterParams,
    keyword = '',
    page,
    rowsPerPage: externalRowsPerPage,
    onPaginationChange,
  }) => {
    const effectivePage = page !== undefined ? page : currentPage;
    const effectiveRowsPerPage = externalRowsPerPage !== undefined ? externalRowsPerPage : rowsPerPage;

    useEffect(() => {
      const filters = {
        productId: filterParams?.product?.id ?? '',
        supplierId: filterParams?.supplier?.id ?? '',
      };
      getStocks({
        keyword,
        page: effectivePage,
        rowsPerPage: effectiveRowsPerPage,
        filters,
      });
    }, [filterParams, getStocks, branchId, keyword, effectivePage, effectiveRowsPerPage]);

    const formatDate = (value) =>
      value
        ? new Date(value).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })
        : '';

    const handlePageChange = useCallback(
      (_, newPage) => {
        if (onPaginationChange) onPaginationChange(newPage, effectiveRowsPerPage);
      },
      [onPaginationChange, effectiveRowsPerPage]
    );

    const handleRowsPerPageChange = useCallback(
      (e) => {
        const value = e?.target?.value != null ? Number(e.target.value) : undefined;
        if (onPaginationChange && typeof value === 'number') onPaginationChange(0, value);
      },
      [onPaginationChange]
    );

    const columns = [
      { id: 'productcode', label: 'Code', minWidth: 60 },
      { id: 'productname', label: 'Product', minWidth: 170 },
      { id: 'initialQty', label: 'Initial Quantity', minWidth: 50, format: (v) => (v != null ? Number(v).toFixed(5) : '') },
      { id: 'qty', label: 'Quantity Remaining', minWidth: 50, format: (v) => (v != null ? Number(v).toFixed(5) : '') },
      { id: 'unit', label: 'Unit', minWidth: 30 },
      { id: 'costOfGoods', label: 'Cost of Goods', minWidth: 100, format: (v) => (v != null ? Number(v).toFixed(2) : '') },
      { id: 'unitCost', label: 'Unit Cost', minWidth: 80, format: (v) => (v != null ? Number(v).toFixed(2) : '') },
      { id: 'unitPrice', label: 'Unit Price', minWidth: 80, format: (v) => (v != null ? Number(v).toFixed(2) : '') },
      { id: 'discount', label: 'Discount', minWidth: 70, format: (v) => (v != null ? Number(v).toFixed(2) : '') },
      { id: 'wholesaleDiscount', label: 'Wholesale Discount', minWidth: 80, format: (v) => (v != null ? Number(v).toFixed(2) : '') },
      { id: 'createdDate', label: 'Created Date', minWidth: 100, format: formatDate },
      { id: 'expireDate', label: 'Expire Date', minWidth: 100, format: formatDate },
      {
        id: 'options',
        minWidth: 20,
        options: ['Update'],
        table: 'stock',
      },
    ];

    const rows = Array.isArray(stocksData) ? stocksData : [];

    return (
      <div className={styles.mainDiv}>
        {isLoading && <Loading variant="overlay" label="Loading..." />}
        <Table
          columns={columns}
          rows={rows}
          page={effectivePage}
          rowsPerPage={effectiveRowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          totalCount={totalRecords}
          disableInternalPagination
          emptyMessage="No stock data available."
        />
      </div>
    );
  }
);

const mapStateToProps = (state) => ({
  auth: state.authState,
  stocksState: state.stocksState,
});

export default connect(mapStateToProps, {
  getStocks,
})(StockTable);
